import { Component, OnInit, Output, EventEmitter, Input, ViewChild, SimpleChanges, OnChanges, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Subject, timer } from 'rxjs';
import { MessagebarComponent } from 'basecomponents';
import { Router, ActivatedRoute } from '@angular/router';
import { SolarBase1Component } from '@solar/solar/solar-base';
import { GlobalService } from '@solar/services/global.service';
import { Site } from 'solar-bo';
import { SolarService } from '@solar/solar/services/solarservice.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem, copyArrayItem } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-site-config',
  templateUrl: './site-config.component.html',
  styleUrls: ['./site-config.component.scss']
  , changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteConfigComponent extends SolarBase1Component implements OnInit, AfterViewInit {

  TAG = "SiteConfigComponent";
  @Output() saveEvent = new EventEmitter<Site>();
  private _site: Site = new Site();
  @Input()
  public get site(): Site {
    return this._site;
  }
  public set site(value: Site) {
    console.log(this.TAG + " site set", value);
    this._site = value;
    this.configData();
  }
  @Input() ismodal: boolean = false;
  @ViewChild('frmsmessagebar') frmsmessagebar: MessagebarComponent;


  report_locator: any[] = [];
  locator: any[] = [];
  panel_locator_pattern: any[] = [];

  public constructor(
    public dialog: MatDialog
    , public globService: GlobalService
    , public route: ActivatedRoute
    , public solarService: SolarService
    , public router: Router
    , private fb: FormBuilder
  ) {
    //super(dialog, globService,route,baseService,router);
    super();
  }

  ngOnInit() {
    this.loading = false;
  }

  ngAfterViewInit() {

  }


  isvalid() {
    return true; //this.myform.valid && !this.submitted;
  }

  ui_showbtn(button: string): boolean {   
    if (!this.site){
      //creando
      return true;
    }
    return this.acl_btn_bysite(button, this.site);
  }

  configData() {
    if (!this.site) {
      return;
    }
    if (this.site.info.locator) {
      this.locator = this.site.info.locator;
      this.configLocator();
    }
    if (this.site.info.report && this.site.info.report.locator) {
      this.report_locator = this.site.info.report.locator;
      this.configReports();
    }


  }

  locatorEdit: any[] = [];
  locatorFormat: string;
  form = new FormGroup({});
  configLocator() {
    let siteLocator = this.locator;//info with description about locator
    let keys = Object.keys(siteLocator);
    let loc: any[] = [];
    for (let k of keys) {
      let avalue: string = "";
      try {
        if (siteLocator) {
          avalue = siteLocator[k];
        }
      }
      catch (err) {
        //
      }
      if (k == "format") {
        this.locatorFormat = avalue
        continue;
      }
      let item = { key: k, value: avalue, tooltip: avalue };
      loc.push(item);
    }
    this.locatorEdit = loc;

    this.form = new FormGroup({});
    this.locatorEdit.forEach(x => {
      //this.form.addControl(x.key, new FormControl(x.value, Validators.required));
      this.form.addControl(x.key, new FormControl(x.value));
    });
  }
  report_locatorEdit1: any = [];
  report_locatorEdit: any = [];
  formReport = new FormGroup({});
  configReports() {
    let _locator = this.report_locator;//info with description about locator
    let keys = Object.keys(_locator);
    let loc: any[] = [];
    for (let k of keys) {

      let avalue: string = "";
      let format: string = "";
      let fields: any[] = [];
      try {
        if (_locator) {
          avalue = _locator[k].name;
          format = _locator[k].format;
          //fields = _locator[k].format;
        }
      }
      catch (err) {
        //
      }


      let item = { key: k, value: avalue, format: format, tooltip: avalue, fields: fields };
      loc.push(item);
    }
    this.report_locatorEdit = loc;
    this.report_locatorEdit1 = loc.slice();
  }

  getNewLocator() {
    let configlocator = this.locatorEdit;
    let newLocator = {};
    for (let level of configlocator) {
      newLocator[level.key] = level.value;
    }
    newLocator["format"] = this.locatorFormat;
    console.log("newlocator", newLocator);
    return newLocator;
  }

  getNewLocatorReports() {
    let configlocator = this.report_locatorEdit;
    let newLocator = {};
    for (let level of configlocator) {
      newLocator[level.key] = { name: level.value, format: `${level.format}` };
    }
    console.log("newlocator report_locatorEdit", newLocator);
    return { "locator": newLocator };
  }

  getConfig() {
    const panel_locator_pattern = {
      list: "[L1].[L2].[L3]-[L4]",
      maps: "[L1].[L2].[L3]-[L4]"
    };
    const res = { locator: {}, report_locator: {}, panel_locator_pattern: panel_locator_pattern }
    res.locator = this.getNewLocator();
    res.report_locator = this.getNewLocatorReports();

    let patternstr = "";
    let suffix = "";
    for (let level of this.locatorEdit) {
      patternstr += `${suffix}[${level.key}]`;
      suffix = ".";
    }
    panel_locator_pattern.list = patternstr;
    panel_locator_pattern.maps = patternstr;
    res.panel_locator_pattern = panel_locator_pattern;
    return res;
  }

  addLocator() {
    let lastKey = this.locatorEdit.length + 1;
    let item = { key: "L" + lastKey, value: "", tooltip: "" };
    this.locatorEdit.push(item);
  }
  removeLastLocator() {
    this.locatorEdit.pop();
  }

  addReportColumn() {
    let lastKey = this.report_locatorEdit.length + 1;
    let item = { key: "L" + lastKey, value: "Column"+ lastKey, format: `{L${lastKey}}`, fields: [] };
    this.report_locatorEdit.push(item);
  }

  removeReportColumn(){
     this.report_locatorEdit.pop();
  }

  dropReport(event: CdkDragDrop<any[]>) {
    //console.log("layersListMenu", this.layersListMenu);
    console.log(event);
    const prevIndex = this.report_locatorEdit.findIndex((d) => d === event.item.data);
    moveItemInArray(this.report_locatorEdit, prevIndex, event.currentIndex);
    console.log(event);
    let idx = 0;
    for (let level of this.report_locatorEdit) {
      idx += 1;
      level.key = "L" + idx;
    }
    /*  if (event.previousContainer === event.container) {
       moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
       //console.log("layersListMenu after", this.layersListMenu);
       this.reportChangeOrder(this.report_locatorEdit);
     } else {
       //este seria para moverlo a otra lista
       transferArrayItem(event.previousContainer.data,
         event.container.data,
         event.previousIndex,
         event.currentIndex);
     } */
  }
  private reportChangeOrder(list: []) {
    console.log(list);
    for (let x = 0; x < list.length; x++) {
      const layer = list[x];


    }
  }

  dropReportColumnField(event: CdkDragDrop<any[]>) {
    console.log("dropReportColumnField", event);

    if (event.previousContainer === event.container) {
      console.log("dropReportColumnField, If the same");
      if (event.previousContainer.id == "cdk-drop-list-locators") {
        return;
      }
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      console.log("dropReportColumnField, transferArrayItem");
      if (event.previousContainer.id == "cdk-drop-list-locators") {
        copyArrayItem(event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex);

          this.configReportFields();
      }

    }
  }


  private configReportFields() {
    let entries = this.report_locatorEdit;//info with description about locator
    for (let entry of entries) {
      let format: string = "";
      let fields = entry.fields;
      for (let f of fields){
        format+= `{${f.key}}`;
      }
      entry.format=format;

    }
  }

}
